import React from "react";
import { Col, Row } from "@themesberg/react-bootstrap";
import { ProductListComponent } from "../components/ProductListComponent";

export default function ProductList() {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <h4>Products List</h4>
      </div>
      <Row>
        <Col xs={12}>
          <ProductListComponent />
        </Col>
      </Row>
    </>
  );
}
